module.exports = __webpack_public_path__ + "img/img28.c02c1373.png";